import { useMemo } from "react"

import { useRiskZoneCluster } from "../../hooks/queries/useRiskZoneClusters"

import * as Styled from "./RiskZoneDocumentList.styled"

export const RiskZoneDocumentList = (props) => {
    const { riskZoneId } = props

    const { data } = useRiskZoneCluster(riskZoneId)

    const riskZone = useMemo(() => {
        if (data) {
            return data.find(zone => zone.risk_zone.identifier === parseInt(riskZoneId))
        }
        return null
    }, [data, riskZoneId])

    return <Styled.List documents={riskZone?.documents} subNetworks={riskZone?.sub_networks} />
}